import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { CategoryService } from 'src/app/_service/category.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { MycontentserviceService } from 'src/app/_service/mycontentservice.service';
import { Router } from '@angular/router';
import { URLS } from 'src/app/constants/URLS';
import { WalletinfoService } from 'src/app/_service/walletinfo.service';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { UserchannelService } from 'src/app/_service/userchannel.service';
import { environment } from 'src/environments/environment';
import { sampleChannelData, sampleGenreData, sampleLanguageData } from 'src/app/constants/sample';
import { forkJoin, Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { WatchHistoryService } from 'src/app/_service/watch-history.service';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { FeedcacheService } from 'src/app/_service/feedcache.service';
import { IosBridgeService } from 'src/app/_service/ios-bridge.service';
import { AxinomDrmService } from 'src/app/_service/axinom-drm.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { getVideoStreamFile } from 'src/app/utils/media-url.utils';
import { TVNavigationService, Zone } from 'src/app/_service/tv-navigation.service';
import { TVFocusMemoryService } from 'src/app/_service/tv-focus-memory.service';
import { AD_CONFIG } from 'src/app/constants/ad-config';
import { AdResolverService } from 'src/app/_service/ad-resolver.service';
import { NATIVE_ADS } from 'src/app/constants/native-ads.config';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { LoginPromptComponent } from '../../sharedComponents/login-prompt/login-prompt.component';
import { MatDialog } from '@angular/material/dialog';
// import { title } from 'process';

@Component({
  selector: 'app-category-movie',
  templateUrl: './category-movie.component.html',
  styleUrls: ['./category-movie.component.css']
})

export class CategoryMovieComponent implements OnInit, AfterViewInit, OnDestroy {
  userId: string = '';

  /** Single source of truth for the ad layout's breakpoint. `device.isMobile()`
      reads window.innerWidth live, so caching it once at construction left the
      ad slots stale after a resize: a desktop-loaded page narrowed past 768px
      asked for a native ad it had already thrown away, and rendered an empty
      gap. Everything ad-related now derives from this one field. */
  isMobileView = false;

  get adConfig(): any {
    return this.isMobileView ? AD_CONFIG.mobile.banner : AD_CONFIG.desktop.leaderboard;
  }

  /** Native ads are mobile-only; desktop gets a banner in that slot instead. */
  get nativeAd(): any {
    return this.isMobileView ? NATIVE_ADS.primary : null;
  }

  /** Angular only runs change detection for a resize if something listens for it,
      so this handler is what makes the getters above re-evaluate. Re-render only
      when the breakpoint actually flips, not on every pixel of a drag. */
  @HostListener('window:resize')
  onWindowResize(): void {
    const mobile = this.device.isMobile();
    if (mobile !== this.isMobileView) {
      this.isMobileView = mobile;
      this.cdr.markForCheck();
    }
  }

  // TV Hero Preview state
  tvPreviewMovie: any = null;
  tvPreviewVisible = false;
  tvActiveIsChannel: boolean = false;
  tvActiveSectionIndex: number = -1;
  private tvPreviewSetThisTick = false;
  private pendingFocusRestore: any = null;
  // Snapshot of the component's own route. Captured once in ngOnInit and used
  // when calling focusMemory.saveFocusPosition. Without this, ngOnDestroy and
  // late-firing focus subscribers can read this.router.url AFTER it has
  // already changed to the destination URL — saving the *old* component's
  // active region under the *new* URL's key, breaking focus restoration.
  private componentRoute: string = '';
  private repositionTimers: number[] = [];
  private rowResizeObserver: ResizeObserver | null = null;
  private scrollDriftHandler: (() => void) | null = null;
  private expectedScrollTop: number = 0;
  imgUrl: string = URLS.imgUrl;
  private destroy$ = new Subject<void>();

  constructor(
    private categ:CategoryService,
    private mycontentService: MycontentserviceService,
    private router:Router,
    private walletService: WalletinfoService,
    private toastrService: CustomControlsService,
    private userChannelService: UserchannelService,
    private cdr: ChangeDetectorRef,
    private whitelabelService: WhiteLabelService,
    private feedCache: FeedcacheService,
    private bridgeService: IosBridgeService,
    private axinomService: AxinomDrmService,
    public device: DeviceService,
    private tvNav: TVNavigationService,
    private focusMemory: TVFocusMemoryService,
    public adResolver: AdResolverService,
    private authService: AuthenticateserviceService,
    private dialog: MatDialog
  ) {
    this.isMobileView = this.device.isMobile();
    this.userId = localStorage.getItem('userId');
    this.axinomService.loadDrmData(this.userId);
  }

  serverDown:boolean = false;
  bannerList:any[];
  sections:any[];

  /** The sections that actually paint a carousel. The feed ships many sections
      with `category_data: []`, and banner sections render in their own loop up
      top — but both still occupied a row in the main loop, so an ad slot keyed
      on the raw index landed inside an invisible container. With 30 sections and
      only 10 populated that stacked five ads into two piles. Everything the main
      loop indexes (ads, TV focus, channel insertion) counts THIS list. */
  displaySections:any[] = [];

  private hasContent(section: any): boolean {
    return section?.template !== 'banner-horizonal-scrollview'
      && !!section?.category_data?.length;
  }

  /** Single write path for `sections`, so `displaySections` can never drift. */
  private setSections(list: any[]): void {
    this.sections = list || [];
    this.displaySections = this.sections.filter(s => this.hasContent(s));
  }
  channelUrl:string = URLS.channelUrl;
  isLoading:boolean = false;
  continueWatching:any[] = [];
  primeChannels:any[] = [];
  channelData = sampleChannelData;
  genreData = sampleGenreData;
  languageData = sampleLanguageData;
  channel_id:string = '1';
  carouselInteracting = false;

  ngOnInit(): void {
    this.isLoading = true;
    const cachedChannels = this.feedCache.getPrimeChannels();
    if (cachedChannels) {
      this.primeChannels = cachedChannels;
    } else {
      this.getPrimeChannels();
    }
    const cachedSections = this.feedCache.getSections();
    const cachedContinue = this.feedCache.getContinueWatching();
    if (cachedSections && cachedContinue) {
      this.setSections(cachedSections);
      this.continueWatching = cachedContinue;
      this.isLoading = false;
      this.cdr.detectChanges();
      this.getCategoryData(this.channel_id, false);
    } else {
      this.getCategoryData(this.channel_id, true);

    }

    // TV Hero Preview: listen to focus changes on carousel rows
    if (this.device.isTV()) {
      this.componentRoute = this.router.url;
      this.setupTvHeroPreview();

      // Read saved focus position NOW, before banner auto-activation
      // overwrites it in the focus$ subscriber below.
      this.pendingFocusRestore = this.focusMemory.restoreFocusPosition(this.router.url);

      if(this.pendingFocusRestore){
        this.tvNav.setPendingRestore(true);
        setTimeout(()=> this.tvNav.setPendingRestore(false),5000);
      }
      // Fast path — subscribe to region-registration events HERE in ngOnInit,
      // not in ngAfterViewInit. Angular fires children's ngAfterViewInit BEFORE
      // this component's, so by the time ngAfterViewInit runs the section rows
      // have already called tvNav.registerRegion and the Subject's emissions
      // have been missed. Subscribing in ngOnInit means the subscription is
      // active during the children's mount cycle.
      if (this.pendingFocusRestore && this.tvNav.regionRegistered$) {
        const targetId = this.pendingFocusRestore.regionId;
        // No take(1) — keep listening for re-registrations. Continue Watching
        // and other async-loaded rows register AFTER their API data lands,
        // which is often >600ms after page mount. The slow-path safety-net
        // would have given up by then. The filter's pendingFocusRestore check
        // ensures we don't re-fire once successfully restored.
        // Pass attemptsLeft=5 so a failed activation (e.g., items not yet
        // focusable because just rendered) gets retried for ~750ms.
        this.tvNav.regionRegistered$
          .pipe(
            filter(id => id === targetId && this.pendingFocusRestore !== null),
            takeUntil(this.destroy$),
          )
          .subscribe(() => this.tryRestore(15));
      }

      // Continuously save focus position so it's always current when navigating away
      this.tvNav.focus$
        .pipe(takeUntil(this.destroy$))
        .subscribe(focusKey => {
          if (!focusKey) return;
          // Skip saving during the initial restoration window — banner
          // auto-activates at ~50ms and would overwrite the saved carousel position.
          if (this.pendingFocusRestore) return;
          const regionId = this.tvNav.getActiveRegionId();
          const index = this.tvNav.getFocusedIndex();
          // Skip the home banner — it auto-activates on every mount and would
          // clobber the carousel position we want to restore after a back-nav.
          if (regionId && !regionId.includes('sidebar') && !regionId.startsWith('home-banner')) {
            this.focusMemory.saveFocusPosition({
              regionId,
              index,
              timestamp: Date.now(),
              route: this.componentRoute
            });
          }
        });
    }
  }

  ngAfterViewInit(): void {
    if (!this.device.isTV()) return;

    // Slow path / safety net — fires 600ms after view init in case the fast
    // path subscription (set up in ngOnInit) didn't catch the registration
    // (e.g., region was already registered synchronously before subscribe ran,
    // or the saved region just doesn't exist on this page).
    const initialTimer = window.setTimeout(() => this.tryRestore(10), 600);
    this.repositionTimers.push(initialTimer);

    // Late safety net at 2500ms — handles async-loaded rows like Continue
    // Watching that may register after the initial 600ms slow-path gave up.
    // tryRestore is a no-op if pendingFocusRestore is null (already restored),
    // so this only fires meaningfully when the prior paths failed.
    const lateTimer = window.setTimeout(() => this.tryRestore(10), 2500);
    this.repositionTimers.push(lateTimer);

    // Late-late safety net at 4500ms — for slow-mounting content types where
    // returning from details takes longer (TV shows /shows/ and shorts /shorts/
    // observed in 20-cycle test to miss the 2500ms window ~30% of the time).
    // Idempotent: if pendingFocusRestore is null at this point, it does nothing.
    const lateLateTimer = window.setTimeout(() => this.tryRestore(10), 4500);
    this.repositionTimers.push(lateLateTimer);
  }

  /**
   * Activate the saved focus region. Called from two paths:
   *   - Fast path: ngOnInit's regionRegistered$ subscription (attemptsLeft=0)
   *   - Slow path: ngAfterViewInit's 600ms safety-net timer (attemptsLeft=10)
   *
   * If activation doesn't immediately take effect (no .tv-focus in the DOM),
   * retry every 150ms up to attemptsLeft times, then give up gracefully.
   */
  private tryRestore(attemptsLeft: number): void {
    if (this.tvNav.hasLastContentFocus()) {
      this.pendingFocusRestore = null;
      this.tvNav.setPendingRestore(false);
      // Even when nav service has its own restoration, run the row
      // reposition defender so initial-load scroll lands at the correct
      // row position.
      this.scheduleActiveRowReposition();
      return;
    }

    const saved = this.pendingFocusRestore;
    if (!saved) {
      // Already restored by another path, or there was nothing to restore.
      // The cold-start scroll-to-top is owned by the slow-path's first call;
      // subsequent retries should not keep nudging scroll.
      return;
    }

    this.tvNav.activateRegion(saved.regionId, saved.index);
    this.scheduleActiveRowReposition();

    // If activation didn't take effect because the saved region wasn't
    // registered yet, try again in 150ms. Up to attemptsLeft retries.
    const focused = document.querySelector('.tv-focus');
    if (!focused && attemptsLeft > 0) {
      const timer = window.setTimeout(() => this.tryRestore(attemptsLeft - 1), 150);
      this.repositionTimers.push(timer);
      return;
    }

    // Activation succeeded (or we've exhausted retries).
    if (focused) {
      // 1) Pull the focused card into view — common need for rows below the fold
      // on a fresh re-mount, since scheduleActiveRowReposition computes against
      // a stale tvActiveSectionIndex on first activation.
      (focused as HTMLElement).scrollIntoView({ block: 'center', behavior: 'auto' });

      // 2) Sync the hero preview directly. The normal chain
      // (activateRegion → focusSubject.next → row's tvFocusedMovie emit →
      // parent's onTvFocusedMovie) doesn't fire reliably on programmatic
      // restore — the row's emit guard `focusedCardIndex < this.movies?.length`
      // can race with template-input binding right after a re-mount. Calling
      // onTvFocusedMovie here ourselves guarantees the hero preview catches up.
      this.syncHeroPreviewToSavedRegion(saved.regionId, saved.index);

      // 3) Defensive re-activate (two passes). After our restore, banner or
      // another region's auto-activation can steal focus. The user can't
      // possibly have D-pad'd away within ~700ms of returning to the page,
      // so any drift from the saved position in that window is a race we
      // should undo. Two checks (500ms + 1200ms) catch both fast and slow
      // steals (e.g., Continue Watching's async-loaded row registering late).
      const savedFinal = saved;
      const isDriftFromSaved = () => {
        const current = this.tvNav.getActiveRegionId();
        return current && current !== savedFinal.regionId;
      };
      const reapplyIfDrifted = () => {
        if (isDriftFromSaved()) {
          this.tvNav.activateRegion(savedFinal.regionId, savedFinal.index);
          const restored = document.querySelector('.tv-focus');
          if (restored) {
            (restored as HTMLElement).scrollIntoView({ block: 'center', behavior: 'auto' });
          }
        }
      };
      this.repositionTimers.push(window.setTimeout(reapplyIfDrifted, 500));
      this.repositionTimers.push(window.setTimeout(reapplyIfDrifted, 1200));
      // Extended defensive window for slow-mounting content (TV shows, shorts)
      // where the back-nav focus steal happens 2-4 seconds in. Each timer uses
      // the captured savedFinal value — independent of pendingFocusRestore
      // which may have been cleared by earlier paths.
      this.repositionTimers.push(window.setTimeout(reapplyIfDrifted, 2500));
      this.repositionTimers.push(window.setTimeout(reapplyIfDrifted, 4000));
    }
    this.pendingFocusRestore = null;
    this.tvNav.setPendingRestore(false);
  }

  /**
   * Look up the section + movie corresponding to a saved focus region and
   * trigger the hero-preview update path directly. Only handles the
   * `section-{categoryId}` shape used by the standard movie carousels;
   * other region types (banner, sidebar) are skipped, which is correct
   * because they don't drive the hero-preview anyway.
   */
  private syncHeroPreviewToSavedRegion(regionId: string, index: number): void {
    if (!regionId.startsWith('section-')) return;
    const categoryId = regionId.slice('section-'.length);
    // Indexes displaySections, because that is what the template's *ngFor emits
    // — against the raw list the restored focus landed on the wrong row.
    if (!this.displaySections.length) return;
    const sectionIndex = this.displaySections.findIndex(
      (s: any) => s && String(s.categoryId) === categoryId
    );
    if (sectionIndex < 0) return;
    const movie = this.displaySections[sectionIndex]?.category_data?.[index];
    if (!movie) return;
    this.onTvFocusedMovie(movie, sectionIndex);
  }

  ngOnDestroy(): void {
    // Save TV focus position for restoration when returning
    if (this.device.isTV()) {
      const regionId = this.tvNav.getActiveRegionId();
      const index = this.tvNav.getFocusedIndex();
      // Mirror the focus$ subscriber: do not persist the home banner position.
      if (regionId && !regionId.startsWith('home-banner')) {
        this.focusMemory.saveFocusPosition({
          regionId,
          index,
          timestamp: Date.now(),
          route: this.componentRoute
        });
      }
    }
    this.tvNav.skipVerticalScroll = false;
    this.tvNav.setPendingRestore(false);
    this.cancelActiveRowReposition();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setupTvHeroPreview(): void {
    // Listen to zone changes — only show preview when in content zone
    this.tvNav.zone$
      .pipe(takeUntil(this.destroy$))
      .subscribe(zone => {
        if (zone !== Zone.CONTENT) {
          this.tvPreviewVisible = false;
          this.tvActiveSectionIndex = -1;
          this.tvNav.skipVerticalScroll = false;
          this.cdr.detectChanges();
        }
      });

    // Track focus changes to hide preview when focus leaves movie-thumbnail carousels
    this.tvNav.focus$
      .pipe(takeUntil(this.destroy$))
      .subscribe(focusKey => {
        // Explicitly hide for sidebar/banner
        if (!focusKey || focusKey.startsWith('main-sidebar:') || focusKey.startsWith('banner')) {
          this.tvPreviewVisible = false;
          this.tvActiveSectionIndex = -1;
          this.tvNav.skipVerticalScroll = false;
          this.cdr.detectChanges();
          return;
        }

        // For other focus changes, check if onTvFocusedMovie fires in the same tick
        this.tvPreviewSetThisTick = false;
        Promise.resolve().then(() => {
          if (!this.tvPreviewSetThisTick && this.tvPreviewVisible) {
            this.tvPreviewVisible = false;
            this.tvActiveSectionIndex = -1;
            this.tvNav.skipVerticalScroll = false;
            this.cdr.detectChanges();
          }
        });
      });
  }

  onTvFocusedMovie(movie: any, sectionIndex?: number, isChannel: boolean= false): void {
    if (movie) {
      this.tvActiveIsChannel = isChannel;
      this.tvPreviewSetThisTick = true;
      this.tvPreviewMovie = movie;
      this.tvPreviewVisible = true;
      // Only reposition the page when the *row* changes. Moving left/right
      // within the same row must not re-run scrollTo, otherwise each keypress
      // re-pins the row and visibly jumps it toward the top of the screen.
      const rowChanged = sectionIndex !== undefined && sectionIndex !== this.tvActiveSectionIndex;
      if (sectionIndex !== undefined) {
        this.tvActiveSectionIndex = sectionIndex;
      }
      this.cdr.detectChanges();

      // Tell TVNavigationService to skip its scroll — we handle it ourselves
      if (this.device.isTV()) {
        this.tvNav.skipVerticalScroll = true;
        if (rowChanged) {
          this.scheduleActiveRowReposition();
        }
      }
    }
  }

  onTvFocusedChannel(channel:any, sectionIndex:number):void{
    if(!channel) return;
    const adapted = {
      title: channel.name || channel.channelName || channel.title || '',
      tvHeroImage: channel.imageUrl,
      pg_rating: null,
      language: null,
      genres: [],
      synopsis: channel.description || channel.synopsis || ''
    };
    this.onTvFocusedMovie(adapted, sectionIndex, true);
  }

  /**
   * Reposition the active row so its bottom sits at the viewport bottom.
   *
   * Listens to layout shifts from THREE sources for the entire time the row
   * stays active:
   *   1. The row itself shrinking/growing (lazy images, *ngFor settling)
   *   2. Anything ABOVE the row growing/shrinking — most commonly the banner
   *      auto-sliding at +3s into a slide whose hero image/trailer renders
   *      at a different height. Without observing the document, the banner
   *      shift goes uncorrected and the row visually drifts onto the hero
   *      (the hero is position:fixed, so a fixed-scrollY page shows the row
   *      overlapping it once banner content above shrinks).
   *   3. Late-arriving content (ad-banner network load, native carousel
   *      sub-component layout) anywhere in the page.
   *
   * Observer stays connected until the next row change OR component destroy
   * — disconnecting early (the prior 2s timeout) was the bug: the banner
   * auto-slides at 3s, after the observer was already gone.
   *
   * Math uses offsetTop + clientHeight (document-absolute) so each call is
   * idempotent — independent of current scrollY, no compounding errors.
   */
  private scheduleActiveRowReposition(): void {
    this.cancelActiveRowReposition();

    const reposition = () => {
      const activeRow = document.querySelector('.tv-active-row') as HTMLElement | null;
      if (!activeRow) return;
      const rowDocBottom = activeRow.offsetTop + activeRow.clientHeight;
      const targetScrollTop = Math.max(0, rowDocBottom - window.innerHeight);
      this.expectedScrollTop = targetScrollTop;
      if (Math.abs(window.scrollY - targetScrollTop) > 1) {
        window.scrollTo(0, targetScrollTop);
      }
    };

    // Run once after first paint commits layout.
    requestAnimationFrame(() => requestAnimationFrame(reposition));

    // Initial defender: run reposition every 50ms for 1.5 seconds. Catches
    // competing scrolls during the route-mount window (banner auto-activation
    // scrollTo, scrollVerticalOnly, etc.). Each call is idempotent.
    let defenderTicks = 30;
    const defenderId = window.setInterval(() => {
      if (defenderTicks-- <= 0) {
        window.clearInterval(defenderId);
        // After the 1.5s settle window, attach the long-lived observers
        // ONLY for shifts beyond a meaningful threshold (>30px), so small
        // layout settle (image lazy-load, hero preview re-paint) doesn't
        // trigger a visible snap. This prevents the "row jumps to top
        // every few seconds while user is sitting on a carousel" jitter.
        this.installPersistentRepositionGuard(reposition);
        return;
      }
      reposition();
    }, 50);
    this.repositionTimers.push(defenderId);
  }

  /**
   * After the initial 1.5s defender window, attach a tolerant guard that
   * only re-repositions when the drift is significant (> 30px). This avoids
   * the visible bounce from minor layout shifts (lazy-loaded images, hero
   * preview re-paint on RIGHT navigation, ad-banner mount) which were
   * causing the "row moves to top then snaps back" jitter.
   */
  private installPersistentRepositionGuard(reposition: () => void): void {
    const DRIFT_THRESHOLD_PX = 30;
    if (typeof ResizeObserver !== 'undefined') {
      this.rowResizeObserver = new ResizeObserver(() => {
        // Only act if drift is large — small re-paints don't matter visually.
        if (Math.abs(window.scrollY - this.expectedScrollTop) > DRIFT_THRESHOLD_PX) {
          reposition();
        }
      });
      this.rowResizeObserver.observe(document.documentElement);
      const activeRow = document.querySelector('.tv-active-row') as HTMLElement | null;
      if (activeRow) {
        this.rowResizeObserver.observe(activeRow);
      }
    }

    // Scroll drift handler: only re-correct when drift is significant.
    // Small browser-driven scrolls (focus into view, scroll-anchoring) under
    // the threshold are left alone — no bounce.
    this.scrollDriftHandler = () => {
      if (Math.abs(window.scrollY - this.expectedScrollTop) > DRIFT_THRESHOLD_PX) {
        reposition();
      }
    };
    window.addEventListener('scroll', this.scrollDriftHandler, { passive: true });
  }

  private cancelActiveRowReposition(): void {
    this.repositionTimers.forEach(id => {
      window.clearTimeout(id);
      window.clearInterval(id);
    });
    this.repositionTimers = [];
    this.rowResizeObserver?.disconnect();
    this.rowResizeObserver = null;
    if (this.scrollDriftHandler) {
      window.removeEventListener('scroll', this.scrollDriftHandler);
      this.scrollDriftHandler = null;
    }
  }

  getTvPreviewImage(): string {
    if (!this.tvPreviewMovie) return '';
    if (this.tvPreviewMovie.tvHeroImage) return this.tvPreviewMovie.tvHeroImage;
    const id = this.tvPreviewMovie.series_id || this.tvPreviewMovie.vidLibId;
    const prefix = this.tvPreviewMovie.series_id ? 'SER' : 'VID';
    return `${this.imgUrl}${prefix}_${id}_thumb_high.jpg`;
  }

  navigateToHistory(event: Event): void {
    event.stopPropagation();
    const target = event.target as HTMLElement;
    if (target.closest('.category-header') && !target.closest('app-spread-carousel')) {
      this.router.navigate(['/history']);
    }
  }

  onCarouselTouchStart(): void {
    this.carouselInteracting = true;
  }

  onCarouselTouchEnd(): void {
    setTimeout(() => {
      this.carouselInteracting = false;
    }, 100);
  }

  navigateToHistoryConditional(event: Event): void {
    if (!this.carouselInteracting) {
      this.router.navigate(['/history']);
    }
  }

  getEnglishText(section: any): string {
    const enText = section.section_language_text?.find(lang => lang.lang_id === 'en_US');
    return enText?.lang_text || '';
  }
  
  getPrimeChannels() {
    this.userChannelService.getPrimeChannels().subscribe({
      next: (result) => {
        if (result && Array.isArray(result)) {
          this.primeChannels = result.map((item) => {
            return {
              ...item,
              imageUrl: `${this.channelUrl}CH_${item.channelId}_thumb.jpg`,
              isSubscribed: false
            };
          });
          this.feedCache.setPrimeChannels(this.primeChannels);
          this.cdr.detectChanges();
        } else {
          this.primeChannels = [];
        }
      },
      error: (error) => {
        this.primeChannels = [];
      },
      complete: () => {
        console.log('🏁 getPrimeChannels call completed');
      }
    });
  }

  openCategoryPage(id:string){
    this.router.navigate(['category',id])
  }
  
  getCategoryData(channel_id: any, showLoading: boolean = true) {
    if (showLoading) this.isLoading = true;
    const userId = localStorage.getItem('userId');
    forkJoin({
      sections: this.categ.sectionsdata(channel_id),
      watchlist: this.mycontentService.getWatchListOfUser(userId),
      subscriptions: this.walletService.getUserSubscriptions(),
      watchHistory: this.mycontentService.getContinueWatching()
    }).subscribe(
      ({ sections, watchlist, subscriptions, watchHistory }) => {
        if (sections) {
          this.setSections(sections.map(section => {
            this.transformData(section);
            return section;
          }));
          this.continueWatching = watchHistory;
          this.mapwatchContent(watchlist);
          this.mapSubscription(subscriptions);
          this.mapwatchHistory(this.continueWatching);
          this.feedCache.setSections(this.sections);
          this.feedCache.setContinueWatching(this.continueWatching);
          console.log(this.sections)
        } else {
          this.serverDown = !this.serverDown;
        }
        this.isLoading = false;
        this.cdr.detectChanges(); 
      },
      (error) => {
        this.isLoading = false;
        if (error?.statusText === 'Unknown Error') {
          this.serverDown = !this.serverDown;
        }
        this.cdr.detectChanges(); 
      }
    );
  }

  mapwatchContent(watchresult: any[]) {
    this.sections.forEach(section => {
      section.category_data.forEach(category => {
        category.isInWatchList = watchresult.some(wlitem => category.vidLibId === wlitem.vidLibId);
      });
    });
  }

  mapwatchHistory(watchHistory: any[]) {
    this.sections.forEach(section => {
      section.category_data.forEach(category => {
        const whitem = watchHistory.find(item => item.vidLibId === category.vidLibId);
        if (whitem) {
          category.watchedPercentage = whitem.watchedPercentage;
        }
      });
    });
  }
  
  mapSubscription(subscriptions: any[]) {
    this.sections.forEach(section => {
      section.category_data.forEach(category => {
        category.expiringDate = '';
        subscriptions.forEach(sitem => {
          if (category.channelId == sitem.channelId && sitem.isActive) {
            category.isChannelSubscribed = true;
            category.expiringDate = sitem.dateOfExpiry;
          }
          if ((category.vidLibId == sitem.contentId || category.vidLibId == sitem.vidLibId) && sitem.isActive) {
            category.isPPVSubscribed = true;
            category.expiringDate = sitem.dateOfExpiry;
          }else if(category.channelId == sitem.channelId && sitem.isActive && category.sub_value === '0'){
            category.isPPVSubscribed = true;
            category.expiringDate = sitem.dateOfExpiry;
          }
        });
      });
    });
  }

  transformData(data: any) {
    for (const category of data.category_data) {
      category.categoryId = data.categoryId;
      this.mycontentService.transformData(category);
    }
  }

  removeDuplicates(data) {
    const tempObj = {};
    const finalResult = [];
    for(const ele of data) {
      if(!tempObj[ele.vidLibId]){
        finalResult.push(ele);
        tempObj[ele.vidLibId] = ele.vidLibId;
      }
    }
    return finalResult;
  }
  
  getInsertionPoints() {
    // Counted over rendered sections — against the raw list this resolved to an
    // empty container, so "Popular Channels" never appeared where intended.
    const totalSections = this.displaySections.length;
    return {
      channelsAt: Math.floor(totalSections * 0.1), 
      genresAt: Math.floor(totalSections * 0.8),   
      languagesAt: Math.floor(totalSections * 0.9) 
    };
  }

  bannerSlider: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    stagePadding: 0,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    margin:0,
    nav: true,
    autoplay: true,
    navText: ['<i class="fa fa-chevron-left"</i>', '<i class="fa fa-chevron-right"</i>'],
    responsive: {
      0: {
        items: 1,
        stagePadding: 0,
        nav:false,
        margin: 5
      },
      400: {
        items: 1,
        stagePadding: 0,
        nav:false,
        margin: 5
      },
      740: {
        items: 1,
        stagePadding: 0
      },
      940: {
        items: 1,
        stagePadding:0
      }
    },
  };

  onCategoryClick(name: string, id: string, count:number){
    const route = this.whitelabelService.getPrefixedRoute('browse', 'section', id, name);
    this.router.navigate([route],{
      queryParams:{
        count: count
      }
    })
  }

  handleWatchList(event:any){
    if (this.authService.isGuest()) {
      this.dialog.open(LoginPromptComponent, {
        panelClass: 'login-prompt-dialog',
        data: { message: 'Login or Create a Free Account to save to your watchlist' },
        disableClose: this.device.isTV()
      });
      return;
    }
    if(event.isInWatchList){
      this.removeFromWatchList(event);
    }else {
      this.addInWatchList(event);
    }
  }

  addInWatchList(video) {
    event.stopPropagation();
    var userId = localStorage.getItem("userId");
    this.mycontentService.addInWatchList(userId, video.vidLibId).subscribe(result => { 
      if (result.status == 0) {
        video.isInWatchList = true;
        this.showNotication('success', 'successfully added to the watchlist..');
      } else if (result.status == 1) {
        this.showNotication("warning", "unable to add please try again..");
      }
    })
  }

  removeFromWatchList(video) {
    event.stopPropagation();
    var userId = localStorage.getItem("userId");
    this.mycontentService.removeFromWatchList(userId, video.vidLibId).subscribe(result => { 
      if (result.status == 0) {length
        video.isInWatchList = false;
        this.showNotication('success', "successfully removed from the watchlist..");
      } else if (result.status == 1) {
        this.showNotication("warning", "unable to remove please try again..");
      }
    })
  }

  showNotication(type:any, message:any) {
    this.toastrService.showNotification(
      type,
      '',
      message,
      3000
    );
  }

  navigateToPlayer(banner: any){
    if (this.authService.isGuest()) {
      this.dialog.open(LoginPromptComponent, {
        panelClass: 'login-prompt-dialog',
        data: { message: 'Login or Create a Free Account to start watching' },
        disableClose: this.device.isTV()
      });
      return;
    }
    let playerRoute;
    if(banner?.tqrVideoBean?.series_id){
      playerRoute = this.whitelabelService.getPrefixedRoute('shows', banner.tqrVideoBean.series_id, banner.tqrVideoBean.title, banner.tqrVideoBean.vidLibId, 'watch');
    }else{
      playerRoute = this.whitelabelService.getPrefixedRoute('movies', banner.title, banner.vidLibId, 'watch');
    }
    console.log(playerRoute);
    const win = window as any;
    if(win?.AndroidTV && typeof win.AndroidTV.openVideoPlayer === 'function') {
      const payload = {
        videoUrl: `${environment.baseUrl}toqqer/static/post_videos/${getVideoStreamFile(banner)}`,
        drmLicenseUrl: this.axinomService.getWidevineUrl(),
        authToken: this.axinomService.getWidevineToken(),
        videoLibrary: banner
      }
      console.log('banner json', payload);
      win.AndroidTV.openVideoPlayer(JSON.stringify(payload));
      return;
    }
    if (this.bridgeService.isIOS()) {
      const payload = {
        video: banner?.tqrVideoBean?.series_id  ? banner?.tqrVideoBean : banner,
        returnRoute: this.router.url,
        playerUrl: `${this.bridgeService.getCurrentDomain()}${playerRoute}?aspect=${banner?.tqrVideoBean?.mediaLayout}`,
      };
      this.bridgeService.openVideoPlayer(payload);
      return;
    }
    if(banner?.series_id){
      const route = this.whitelabelService.getPrefixedRoute('shows', banner.series_id, banner.title, banner.vidLibId, 'watch');
      this.router.navigate([route]);
    }else{
      const route = this.whitelabelService.getPrefixedRoute('movies', banner.title, banner.vidLibId, 'watch');
      this.router.navigate([route]);
    }
  }

  showPlansModal(hoveredMovie:any){
    if (this.device.isTV()) return;
    const route = this.whitelabelService.getPrefixedRoute('channelplans');
    this.router.navigate([route], {
      queryParams:{
        channelId: hoveredMovie?.channelId,
        channelName: hoveredMovie?.name ? hoveredMovie?.name: hoveredMovie?.channel_desc,
        vidLibId: hoveredMovie?.vidLibId
      }
    })
  }

  openPayments(hoveredMovie:any) {
    if (this.device.isTV()) return;
    const route = this.whitelabelService.getPrefixedRoute('payment');
    this.router.navigate([route], {
      queryParams: {
        type: 'ppv',
        vidLibId: hoveredMovie?.vidLibId,
        movie: hoveredMovie?.title,
        durId: '2',
        planAmount: hoveredMovie.isChannelSubscribed ? hoveredMovie?.sub_value : hoveredMovie?.unSub_value,
        durationName: '2 Weeks',
        currency: hoveredMovie.currencyCode,
        currencySymbol: hoveredMovie.currencySymbol
      }
    });
  }  

  userChannel(channel){
    const route = this.whitelabelService.getPrefixedRoute('channel', 'user');
    this.router.navigate([route], {
      queryParams: {
        channelId: channel.channelId,
        category: 'PRIME'
      }
    });
  }

  onItemClick(item, type){
    const route = this.whitelabelService.getPrefixedRoute('browse', type, String(item?.id), item?.name);
    this.router.navigate([route]);
  }

  openHistory(){
    const route = this.whitelabelService.getPrefixedRoute('continue-watching');
    return route;
  }

  handleMovieAction(event: { movie: any, action: string }) {
    if (event.action === 'remove') {
      this.mycontentService.deleteWatchHistoryEntry(event.movie.vidLibId).subscribe(() => {
        this.continueWatching = this.continueWatching.filter(m => m.vidLibId !== event.movie.vidLibId);
        this.showSuccess(`Removed from history`);
      });
    }
  }

  showSuccess(message:any) {
    this.toastrService.showNotification(
      'success',
      '',
      message,
      3000
    );
  }
}      